import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=13e704a8&"
var script = {}
import style0 from "./AdminLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports